import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi } from './../../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from './../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../../services/admin.service';
import { ToasterService } from '../../../../toaster.service';
@Component({
  selector: 'app-practice-bm-progress-master',
  templateUrl: './practice-bm-progress-master.component.html',
  styleUrls: ['./practice-bm-progress-master.component.css']
})
export class PracticeBMProgressMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objPM: any = new benchmarkprogressmaster();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pfmType: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
  bmProgressTypeDDList: Object;

  user: any = {};
  isAdmin: boolean = false;
  login_UserID: string;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    searchText: string;
  dataSearch: any;
  tenantUno: any;
  noDataImg: any;
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService, private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService,  private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.noDataImg = this.utilityService.getnodataImage();
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Practice Benchmark");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    //this.modalRef.hide();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.route.queryParams.subscribe((params: Params) => {
      let pfm = params['pfmtype'];
      this.pfmType = (pfm) ? pfm : '';
      

    });
    this.loadPerformanceMaster();
    this.getBMProgressTypeDD();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  
  searchGrid() {
  
      if (this.searchText != "") {
        this.dataset = this.dataSearch.filter(a =>
          a.bmProgressType && a.bmProgressType.toLowerCase().includes(this.searchText.toLowerCase())
          || a.bmProgressName && a.bmProgressName.toLowerCase().includes(this.searchText.toLowerCase())
          || a.bmProgressValueString && a.bmProgressValueString.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }
      else {
        this.dataset = this.dataSearch;
      }
    
  }

  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'bmProgressType', name: 'Progress Type', field: 'bmProgressType', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bmProgressType', 'bmProgressType'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'bmProgressName', name: 'Progress Name', field: 'bmProgressName', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bmProgressName', 'bmProgressName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'bmProgressValueDisplay', name: 'Progress Value', field: 'bmProgressValueDisplay', sortable: true, type: FieldType.string, filterable: false, width: 50,
       
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.selTab = true;

                this.objPM = this.bmProgressMasterData.filter((items: any) => items.id == rdata.id)[0];

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeletePerformanceMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }

 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadPerformanceMaster() {
    this.spinner.show();
    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getBMProgressMaster(inpValue)
      .subscribe(data => {
        

        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              bmProgressName: this.data[i].bmProgressName,
              bmProgressTypeUno: this.data[i].bmProgressTypeUno,
              bmProgressType: this.data[i].bmProgressType,
              bmProgressValue: this.data[i].bmProgressValue,
              bmProgressValueDisplay: this.data[i].bmProgressValue + '%',
              bmProgressValueString: this.data[i].bmProgressValue.toString(),

            };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objPM = new benchmarkprogressmaster();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
     // Swal.fire('Error', 'Please enter the required information.', 'error');

      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return;
    }

    else {
      this.AddEditPerformanceMaster(this.objPM)
    }
  }

  AddEditPerformanceMaster(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}


    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      this.toaster.show('error', 'Error', 'Duplicates are not allowed.');
      return false;
    }
    else {

      let objPF = new benchmarkprogressmaster();
      objPF = data1;
      objPF.bmProgressName = (objPF.bmProgressName) ? objPF.bmProgressName.toString() : '';
      objPF.bmProgressValue = (objPF.bmProgressValue) ? objPF.bmProgressValue : 0;
      objPF.bmProgressTypeUno = objPF.bmProgressTypeUno;
      objPF.userUno = this.login_UserID;
      objPF.condition = (this.pageAction == "add") ? 0 : 1;
      //objPF.tenantUno = this.login_UserID;
      objPF.tableName = this.pfmType;
      objPF.tenantUno = this.tenantUno;
      this.restApi.addEditBMProgressMaster(objPF)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
          else {
            //Swal.fire({
            //  type: 'success',
            //  title: 'Item saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            if (this.pageAction == 'add') {
              this.toaster.show('success', 'Success', 'Item saved.');
            }
            else {
              this.toaster.show('success', 'Success', 'Item updated.');
            }
            setTimeout(() => {
              this.objPM = new benchmarkprogressmaster();
              this.spinner.hide();
              this.loadPerformanceMaster();
              this.modalRef.hide();
            }, 500);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(itemUno: number, nameEn: string, nameAr: string) {
    
    let progressTypeDublicate = [];
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      //progressTypeDublicate=this.data.filter(a => a.bmProgressTypeUno == parseInt(this.objPM.bmProgressTypeUno));
      progressTypeDublicate = this.data;
      progressTypeDublicate.forEach((grdData) => {
        if ((itemUno != grdData.id) 
          &&
          (grdData.bmProgressName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      
        //if (((itemUno != grdData.id) && (itemUno == grdData.id && this.selected_itemUno != grdData.id))
        //  &&
        //  (grdData.bmProgressName.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
        //  rtnValue = true;
        //}

      });

      return rtnValue;
    }
  }


  DeletePerformanceMaster(data1: any) {
    
    let objpfm = new benchmarkprogressmaster();
    objpfm.actionType = this.pageAction;
    objpfm.id = data1.id;
    objpfm.userUno = this.login_UserID;
    objpfm.tenantUno = 1;
    objpfm.tableName = this.pfmType;
    this.restApi.deleteBMProgressMaster(objpfm)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'Item deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadPerformanceMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objPM = new benchmarkprogressmaster();
      this.pageAction = 'add';
    }, 300);


  }
}
